import { ApiError } from '../../api/client'

/**
 * Build an ISO 8601 string in the browser's local timezone (with offset).
 *
 * The server accepts any ISO string with an offset; we send local-time-with-offset
 * so the user's "10:00" on a date means 10:00 local, not 10:00 UTC. The server
 * still validates against the building's timezone.
 */
export function toIsoOffset(date: string, time: string): string {
  if (!date || !time) return ''
  const d = new Date(`${date}T${time}:00`)
  const tzMinutes = -d.getTimezoneOffset()
  const sign = tzMinutes >= 0 ? '+' : '-'
  const hh = String(Math.floor(Math.abs(tzMinutes) / 60)).padStart(2, '0')
  const mm = String(Math.abs(tzMinutes) % 60).padStart(2, '0')
  return `${date}T${time}:00${sign}${hh}:${mm}`
}

/** Return the YYYY-MM-DD that follows `date` in local time. */
export function nextDay(date: string): string {
  const [y, m, d] = date.split('-').map(Number)
  if (!y || !m || !d) return date
  const dt = new Date(y, m - 1, d)
  dt.setDate(dt.getDate() + 1)
  const yyyy = dt.getFullYear()
  const mm = String(dt.getMonth() + 1).padStart(2, '0')
  const dd = String(dt.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

/** Translate booking API error to a user-facing string. */
export function describeBookingError(err: unknown, t: (key: string) => string): string {
  if (err instanceof ApiError) {
    const body = (err.body ?? {}) as { code?: string; message?: string }
    const code = body.code ?? err.message
    const translated = t(`bookings.errors.${code}`)
    if (translated && translated !== `bookings.errors.${code}`) return translated
    if (body.message) return body.message
    return code || t('common.error')
  }
  return t('common.error')
}
